/**
 * Created by patrik.szabo on 02.03.2016.
 */

export default ["Restangular","MaintenanceService","$q", function (Restangular,MaintenanceService,$q) {
    Restangular.addFullRequestInterceptor(function blockRequestInterceptor(element, operation, what, url, headers, params, httpConfig) {
        var result = {};

        if (MaintenanceService.getBlockRequests() && !httpConfig.canNotBeBlocked) {
            var promise = $q.defer();
            promise.resolve();

            result.httpConfig = {
                timeout: promise.promise
            };
        }

        return result;

    });
}];




// WEBPACK FOOTER //
// ./src/ui/app/interceptors/blockRequestInterceptor.js